"use client";
import React, { createContext, useContext, ReactNode } from "react";
import { NumericMarketData } from "../types";

interface MarketDataContextType {
  numericMarketData: NumericMarketData[];
  watchlistId: string;
}

const MarketDataContext = createContext<MarketDataContextType | null>(null);

export const MarketDataProvider: React.FC<{
  children: ReactNode;
  numericMarketData: NumericMarketData[];
  watchlistId: string;
}> = ({ children, numericMarketData, watchlistId }) => {
  return (
    <MarketDataContext.Provider value={{ numericMarketData, watchlistId }}>
      {children}
    </MarketDataContext.Provider>
  );
};

export const useMarketDataContext = () => {
  const context = useContext(MarketDataContext);
  if (!context) {
    throw new Error(
      "useMarketDataContext must be used within MarketDataProvider"
    );
  }
  return context;
};
